import i18n from './../i18n'; // eslint-disable-line

export const handleError = (error, dontRedirectOn404 = false) => {
    let errorMessage = '';
    let errorObject;
    if (error) {
        if (error.data?.status) {
            errorMessage = error.data.status.errorMessage; // eslint-disable-line
            errorObject = error.data.status;
        } else if (error.data?.error) {
            errorMessage = error.data.error;
            errorObject = error.data;
        } else if (error.data) {
            errorMessage = error.data;
            errorObject = error;
        } else {
            errorMessage = error;
        }
        if (error.status === 401 && !dontRedirectOn404) {
            localStorage.clear();
            const loginRedirectUrl = errorMessage.message;
            if (window.location.pathname !== 'logged-out' && loginRedirectUrl && (loginRedirectUrl.indexOf('http') > -1)) {
                window.location = '/no-access';
                window.location = loginRedirectUrl;
            } else if (window.location.pathname !== '/logged-out' && window.location.pathname !== '/no-access') {
                window.location = '/no-access';
            }
        } else {
            return i18n.t('handle-error');
        }
    }
    if (window.console) {
        if (errorObject) {
            console.error(errorObject);
        } else {
            console.log(errorMessage);
        }
    }
    return errorMessage;
};

export default handleError;
